import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import IconEdit from 'material-ui/svg-icons/content/create';
import IconDelete from 'material-ui/svg-icons/action/delete';
import Download from 'material-ui/svg-icons/content/font-download';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import classes from './Activity.scss';

import TaskList from '../../../components/TaskList';
import { DetailField } from '../../../components/DetailField/DetailField';
import ContactCard from '../../../components/ContactCard/ContactCard';
import FileTable from '../../../components/FileTable/FileTable';
import { renderTabCount } from '../../../helpers/renderTabCount';

import { getLocalizedActivityStrings } from '../../../models/Activity';
import FormFileUpload from '../../../components/FormFileUpload/FormFileUpload';
import { simplApiUrlPure } from '../../../api/simplApi';

class Activity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      selectedIndex: 0,
    };
  }

  componentWillMount() {
    this.props.setActivity(this.props.params.activity);
  }

  componentDidMount() {
    this.props.fetchActivity(this.props.params.activity);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    const omit = [
      'fetchActivity',
      'setActivity',
      'setActivityForm',
      'deleteActivity',
      'deleteFile',
      'push',
    ];

    if (
      JSON.stringify(_.omit(nextProps, omit)) !==
      JSON.stringify(_.omit(this.props, omit))
    ) {
      return true;
    }

    return false;
  }

  handleSelect = (index, last) => {
    this.setState({ selectedIndex: index });
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderHeader = () => (
    <header>
      <ul className="breadcrumbs">
        <li>
          <Link to="/activity" activeClassName={classes.activeRoute}>
            {this.props.activityCount} Aktivitäten
          </Link>
        </li>
        <li>
          {this.props.activity.title}
          {this.props.activity.deleted_at === null ? (
            ''
          ) : (
            <span className="deletedTag">gelöscht</span>
          )}
        </li>
      </ul>
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreHorizIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        className="overflow-right"
      >
        <MenuItem
          primaryText="Aktivität bearbeiten"
          leftIcon={<IconEdit className="svg-icon-primary" />}
          key="editActivity"
          className="menu-primary"
          onClick={() => {
            this.props.setActivityForm(this.props.activity.id);
          }}
        />

        <MenuItem
          primaryText="Aktivität löschen"
          leftIcon={
            <IconDelete className="svg-icon-primary svg-icon-warning" />
          }
          key="delActivity"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Löschen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.deleteActivity(this.props.activity.id); // this.props.push('/activity');
                        this.props.router.push('/activity');
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Aktivität wirklich löschen?
                </Dialog>
              ),
            });
          }}
        />
        <MenuItem
          primaryText="Aktivität als PDF exportieren"
          leftIcon={<Download className="svg-icon" />}
          key="downloadActivity"
          className="menu-primary"
          onClick={() => {
            const id =
              typeof this.props.activity.simpl_account === 'string'
                ? this.props.activity.simpl_account
                : this.props.activity.simpl_account.id;
            window.open(
              simplApiUrlPure(
                `export/pdf/activity/${id}/${this.props.activity.id}/${this.props.activity.linkHash}`,
              ),
              '_blank',
            );
          }}
        />
      </IconMenu>
      {this.state.alert}
    </header>
  );
  renderContacts = () => {
    const contacts = [];
    _.forOwn(this.props.persons, value => {
      contacts.push(
        <ContactCard
          name={`${value.name} (K)`}
          avatar={value.avatar}
          key={`contactcard_${value.id}`}
          type="person"
          displayType="small"
          id={value.id}
        />,
      );
    });
    _.forOwn(this.props.staffs, value => {
      contacts.push(
        <ContactCard
          name={`${value.name} (M)`}
          avatar={value.avatar}
          key={`contactcard_${value.id}`}
          type="staff"
          displayType="small"
          id={value.id}
        />,
      );
    });
    if (contacts.length === 0) {
      return <div />;
    }
    return (
      <div className="row overview">
        <div className="col-xs-12 col-sm-3">
          <label>Teilnehmer</label>
        </div>
        <div className="col-xs-12 col-sm-9">{contacts}</div>
      </div>
    );
  };
  renderLinks = () => {
    const output = [];

    if (this.props.company && this.props.company.id) {
      let name = this.props.company.name;
      if (this.props.company.deleted_at !== null) {
        name = `${name} (gelöscht)`;
      }

      output.push(
        <div className="row overview" key="company_link">
          <div className="col-xs-12 col-sm-3">
            <label>Unternehmen</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Link key="companylink" to={`/company/${this.props.company.id}`}>
              {name}
            </Link>
          </div>
        </div>,
      );
    }
    if (Object.keys(this.props.companies).length) {
      const companies = [];
      _.forOwn(this.props.companies, value => {
        let name = value.name;
        if (value.deleted_at !== null) {
          name = `${name} (gelöscht)`;
        }

        companies.push(
          <Link key={`companylink_${value.id}`} to={`/company/${value.id}`}>
            {name}
          </Link>,
        );
      });

      output.push(
        <div className="row overview" key="companies_links">
          <div className="col-xs-12 col-sm-3">
            <label>Beteiligte Unternehmen</label>
          </div>
          <div className="col-xs-12 col-sm-9">{companies}</div>
        </div>,
      );
    }
    if (this.props.project && this.props.project.id) {
      output.push(
        <div className="row overview" key="project_link">
          <div className="col-xs-12 col-sm-3">
            <label>Projekt</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Link key="projectlink" to={`/project/${this.props.project.id}`}>
              {this.props.project.name}
            </Link>
          </div>
        </div>,
      );
    }
    return output;
  };
  renderServiceType = () => {
    if (this.props.serviceType && this.props.serviceKey) {
      return (
        <DetailField
          label="Leistungsart"
          content={`${this.props.serviceType.name} (${this.props.serviceKey.name})`}
        />
      );
    }
  };
  renderTime = () => {
    const extraInfo = getLocalizedActivityStrings(this.props.activity);
    if (extraInfo.sameDay) {
      return (
        <DetailField
          label="Zeitraum"
          content={`${extraInfo.startDateFull}<br />${extraInfo.startTime} - ${extraInfo.endTime}`}
        />
      );
    }
    return (
      <DetailField
        label="Zeitraum"
        content={`${extraInfo.startDate} · ${extraInfo.startTime} bis<br />${extraInfo.endDate} · ${extraInfo.endTime}`}
      />
    );
  };
  renderOverview = () => {
    const activity = this.props.activity;
    const extraInfo = getLocalizedActivityStrings(activity);
    const contactCard =
      typeof this.props.responsible === 'undefined' ? null : (
        <div className="row overview" key="company_link">
          <div className="col-xs-12 col-sm-3">
            <label>Zuständiger</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <ContactCard
              name={this.props.responsible.name}
              avatar={this.props.responsible.avatar}
              key={`contactcard_${this.props.responsible.id}`}
              type="staff"
              displayType="small"
              id={this.props.responsible.id}
            />
          </div>
        </div>
      );
    return (
      <div>
        <section>
          <h2>Allgemein</h2>
          <DetailField label="Thema" content={activity.title} />
          <DetailField
            label="Notiz"
            content={activity.notes}
            className="notes"
          />
          <DetailField label="Priorität" content={activity.priority} />
          <DetailField
            label="Art der Kommunikation"
            content={extraInfo.communicationString}
          />
          {this.renderTime()}
          {this.renderServiceType()}

          {contactCard}

          {this.renderLinks()}

          {this.renderContacts()}
        </section>
      </div>
    );
  };
  render() {
    if (!this.props.activity || Object.keys(this.props.activity).length === 0) {
      // no data loaded yet
      return <div />;
    }
    Tabs.setUseDefaultStyles(false);
    const activity = this.props.activity;
    return (
      <div
        className={
          this.props.activity.deleted_at === null
            ? 'wrapper details-view'
            : 'wrapper details-view deletedModel'
        }
      >
        {this.renderHeader()}
        <Tabs
          onSelect={this.handleSelect}
          selectedIndex={this.state.selectedIndex}
          className="content"
        >
          <TabList activeTabClassName="active">
            <Tab>
              <span>Details</span>
            </Tab>
            <Tab>
              <span>Aufgaben {renderTabCount(this.props.tasks)}</span>
            </Tab>
            <Tab>
              <span>Dateien {renderTabCount(this.props.files)}</span>
            </Tab>
          </TabList>

          <TabPanel>{this.renderOverview()}</TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.tasks, true)} Aufgaben</h2>
            </section>
            <TaskList
              tasks={this.props.tasks}
              showTaskForm
              taskableType="activity"
              taskableId={activity.id}
              showFutureDates
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.files, true)} Dateien</h2>
            </section>
            <section className="no-padding">
              <FileTable
                files={this.props.files}
                deleteFile={this.props.deleteFile}
              />
            </section>
          </TabPanel>
        </Tabs>

        <FormFileUpload
          attachableId={this.props.activity.id}
          attachableType="App\Activity"
          files={[]}
          onUpdate={() => {
            this.props.fetchActivity(this.props.activity.id);
          }}
          invisible
          disabled={this.props.formOpen}
        />
      </div>
    );
  }
}
Activity.propTypes = {
  fetchActivity: PropTypes.func.isRequired,
  setActivity: PropTypes.func.isRequired,
  setActivityForm: PropTypes.func.isRequired,
  deleteActivity: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  activity: PropTypes.object,
  activityCount: PropTypes.number,
  responsible: PropTypes.object,
  persons: PropTypes.array,
  staff: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  staffs: PropTypes.array,
  files: PropTypes.array,
  tasks: PropTypes.array,
  project: PropTypes.object,
  company: PropTypes.object,
  companies: PropTypes.array,
  params: PropTypes.object,
  serviceType: PropTypes.object,
  serviceKey: PropTypes.object,
  router: PropTypes.object,
  formOpen: PropTypes.bool,
};
export default withRouter(Activity);



// WEBPACK FOOTER //
// ./src/routes/ActivityDetail/components/Activity.js